export interface IEmailRecordDTO {
  toEmail: string;
  subject: string;
  fromName: string;
  content: string;
}

export class EmailModelDTO implements IEmailRecordDTO {
  toEmail: string;
  subject: string;
  fromName: string;
  content: string;

  constructor(props: IEmailRecordDTO) {
    this.toEmail = props.toEmail || '';
    this.subject = props.subject || '';
    this.fromName = props.fromName || '';
    this.content = props.content || '';
  }
}
